'use client';
import { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';

import { modalService } from '@/services/modal.service';

const NickNameModal = dynamic(
	() => import('./nickname-modal').then(m => m.NickNameModal),
	{ ssr: false }
);

export const NickNameModalLoader = () => {
	const [shouldRender, setShouldRender] = useState(false);
	const [isOpen, setIsOpen] = useState(false);
	const [isRewardPage, setIsRewardPage] = useState(false);

	useEffect(() => {
		const subscription = modalService.onOpenNickNameModal.subscribe(payload => {
			if (payload.isOpen) {
				setShouldRender(true);
			}
			setIsOpen(payload.isOpen);
			setIsRewardPage(payload.isRewardPage);
		});
		return () => {
			subscription.unsubscribe();
		};
	}, []);

	const handleClose = () => {
		setIsOpen(false);
		modalService.openNickNameModal(false, false);
	};

	if (!shouldRender) {
		return null;
	}

	return (
		<NickNameModal 
			isOpen={isOpen} 
			isRewardPage={isRewardPage} 
			onClose={handleClose}
		/>
	);
};